import { render, staticRenderFns } from "./AddInvoicesPayments.vue?vue&type=template&id=23563989&scoped=true"
import script from "./AddInvoicesPayments.vue?vue&type=script&lang=js"
export * from "./AddInvoicesPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23563989",
  null
  
)

export default component.exports